<template>
  <VModal :isActive="isActive" @clickModal="cancel">
    <transition name="item">
      <div class="form" v-if="isActive">
        <VInput v-model="newNode.content.text" placeholder="name" /><br />
        <VInput style="display:none" v-model="newNode.content.url" placeholder="url" />
        <b-form-checkbox
          v-model="newNode.content.initial"
          name="checkbox-1"
          value="true"
          unchecked-value="false"
            >
          Initial State
        </b-form-checkbox>
        <VInput v-model="newNode.content.color" value='white' placeholder="color" /><br />
        <VInput
          type="number"
          v-model="newNode.width"
          placeholder="width"
        /><br />
        <VInput
          type="number"
          v-model="newNode.height"
          placeholder="height"
        /><br />
        <VSelect v-model="newNode.shape" placeholder="Select State Type">
          <option value="rectangle" selected>User Step (Rectangle)</option>
          <option value="ellipse">Decision/Function Call (Ellipse)</option> </VSelect
        ><br />
        <b-row>
          <b-col>
            <b-form-group label="Description:">
              <b-form-textarea
                v-model="newNode.content.description"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Function:">
              <b-form-textarea
                v-model="newNode.content.function"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-button variant="success" size="sm" @click="ok">OK</b-button>
        <b-button variant="danger" size="sm" @click="cancel">Cancel</b-button>
      </div>
    </transition>
  </VModal>
</template>
<script>
export default {
  props: {
    isActive: Boolean,
    node: {
      type: Object,
      default() {
        return {
          id: "",
          shape: "rectangle",
          width: 150,
          height: 60,
          content: {
            text: "none",
            url: "",
            color: "white",
            initial:false,
            description: '',
            function: ''
          }
        };
      }
    }
  },
  watch: {
    node() {
      this.newWidth = parseInt(this.node.width);
      this.newHeight = parseInt(this.node.Height);
    }
  },
  data() {
    return {
      newNode: this.node
    };
  },
  methods: {
    ok() {
      this.$emit("ok", this.newNode);
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>
<style lang="scss" scoped>
input {
  width: 95%;
  margin-bottom: 5px;
}
select {
  margin-bottom: 5px;
}
.item-enter-active {
  transition: all 0.8s ease;
}
.item-leave-active {
  transition: all 0.3s ease;
}
.item-enter,
.item-leave-to {
  opacity: 0;
}
</style>
